<!-- Start: Rejwan: 14-05-2025 Deregistration (New File) -->
<template>
    <div class="employee-tab-inner">
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="payroll-reporting-tab" id="nav-tabContent-intro" v-if="$acl['gf/leaverlist'] > 0">
                <b-tabs content-class="mt-3 reports-tab pb-4" nav-wrapper-class=" reports-tab-nav">
                    <b-tab active lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Leaver(s).png'"
                                    class="light-mode-icon" />
                                <h5>View Leaver(s)</h5>
                                <p>List of all Former Members of Gratuity Fund</p>
                                <b-button class="btn btn-primary">View</b-button> 
                            </div>
                        </template>
                          
                        <div class="">
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-dereg-leaver-list :pageurl="this.$api_url" is_action="1" from="view_leavers"></gf-dereg-leaver-list>
                            </template>
                            <template v-else>
                                <gf-dereg-leaver-list :pageurl="this.$api_url" is_action="0" from="view_leavers"></gf-dereg-leaver-list>
                            </template>
                        </div> 
                    </b-tab>
                    <!-- <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/De-Registration.png'"
                                    class="light-mode-icon" />
                                <h5>Manual De-Registration</h5>
                                <p>Deregister emplyees from the Gratuity Fund Manually.</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>
                          
                        <div class="">
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-dereg-manual :pageurl="this.$api_url" is_action="1"></gf-dereg-manual>
                            </template>
                            <template v-else>
                                <gf-dereg-manual :pageurl="this.$api_url" is_action="0"></gf-dereg-manual>
                            </template>
                            
                        </div> 
                    </b-tab> -->
                </b-tabs>
            </div>
        </b-overlay>
    </div>
</template>
<script>
export default{
    props: ['flg','pageurl'],
    data(){      
        return {
            dreg_show:1,
            showoverlay:false,
        }
    },
}
</script>
<!-- End: Rejwan: 14-05-2025 Deregistration (New File) -->